import dayjs from 'dayjs';

export const percentFormatter = (
  value: number,
  commonValue: number | undefined,
  numOfDigitsAfterPoint: number = 1,
): string => {
  if (commonValue !== undefined) {
    const percentValue = ((value * 100) / commonValue).toFixed(
      numOfDigitsAfterPoint,
    );
    return `${value} (${percentValue}%)`;
  } else {
    return `${value}`;
  }
};

export const dateFormatter = (date: number, format: string): string => {
  return dayjs(date * 1000).format(format);
};

export const phoneNumberFormatter = (
  phoneNumber: string,
): string => {
  return phoneNumber
    .replace(/^0+/, '')
    .replace(/[^\d]/g, '')
};
